import { heapTracker } from '@/flagsmith/tracker';
import flagsmith from '@flagsmith/flagsmith';
import { ResolveFlagsmithProvider } from '@resolve_medical_bills/flagsmith/react';
import React from 'react';

type props = {
  children: React.ReactNode;
};

export const CustomFlagsmithProvider = ({ children }: props) => {
  return (
    <ResolveFlagsmithProvider
      flagsmith={flagsmith}
      tracker={heapTracker}
    >
      {children}
    </ResolveFlagsmithProvider>
  );
};
